import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

export default function LocationModel({
  navigateToAfterSelect = null,
  onNavigateConsumed,
}) {
  const navigate = useNavigate();
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState(
    () => localStorage.getItem("selectedCity") || "",
  );

  useEffect(() => {
    const fetchCities = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_APP_DOMAIN}/api/getAllWorkLocations`,
        );
        if (response.data.status) {
          const data = response.data.data;
          setCities(Array.isArray(data) ? data : (data?.data ?? []));
        }
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    };
    fetchCities();
  }, []);

  const handleCitySelect = (city, e) => {
    e?.preventDefault();
    localStorage.setItem("selectedCity", city.name);
    localStorage.setItem("selectedCityId", city.id);
    setSelectedCity(city.name);
    window.dispatchEvent(new Event("cityChange"));

    const modalEl = document.getElementById("locationModal");
    if (modalEl && window.bootstrap) {
      const inst = window.bootstrap.Modal.getInstance(modalEl);
      inst?.hide();
    }

    if (navigateToAfterSelect) {
      navigate(navigateToAfterSelect);
      onNavigateConsumed?.();
    }
  };

  return (
    <div
      className="modal moreInfo_modal fade"
      id="locationModal"
      tabIndex="-1"
      aria-labelledby="locationModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog locationSelect_modal-dialog">
        <div className="modal-content locationSelect_modal-content">
          <div className="modal-body locationSelect_modal-body">
            <div className="body_text mb-0">
              <div className="locationSelect_body">
                <div className="locationSelect_body_right">
                  <h3>Select Current City</h3>
                  <p>Your location suggestions will be based on the city</p>
                  <div className="selct-city">
                    {cities.map((city) => (
                      <a
                        key={city.id}
                        href="#!"
                        className={`item${selectedCity === city.name ? " active" : ""}`}
                        onClick={(e) => handleCitySelect(city, e)}
                      >
                        {city.name}
                      </a>
                    ))}
                    {cities.length === 0 && (
                      <p className="p-2 text-muted mb-0">Loading cities...</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
